/**
 * Example JavaScript singleton module
 */

var Menu = (function($) {
  function initMenu() {
    var t1 = gsap.timeline({
      paused: true,
      onStart: function() {
        document.body.classList.add("has-nav");
        setTimeout(() => {
          $(".header-hamburger__cta").text("(CERRAR) X");
        }, 400);
      },
      onReverseComplete: function() {
        document.body.classList.remove("has-nav");
        $(".header-hamburger__cta").text("MENU");
      }
    });

    // Animación del contenedor del menú
    t1.to(".header-nav", {
      duration: 1.3,
      height: "100%",
      ease: "expo.inOut"
    });

    // Animación de los items del menú, más sutil y con fade + desplazamiento
    t1.fromTo(
      ".header-menu__item",
      {
        y: 20,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.08
      },
      "-=0.6" // empieza antes de terminar el bloque anterior
    );

    t1.fromTo(
      ".header-nav-bottom",
      {
        y: 20,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.08
      },
      "-=0.4" // empieza antes de terminar el bloque anterior
    );

    // Invertido por defecto
    t1.reverse();

    // Evento de toggle
    $(document).on("click", function(event) {
      if (
        $(event.target).is(".hamburger__cta") ||
        $(event.target).closest(".hamburger__cta").length
      ) {
        t1.reversed(!t1.reversed());
      } else if (
        $(event.target).is(".header-menu__item a") ||
        $(event.target).closest(".header-menu__item a").length
      ) {
        t1.reversed(!t1.reversed());
      }
    });

    // Evento de toggle
    $(document).on("click", function(event) {
      const contactoLink = $(event.target).closest(
        ".header-menu__item--contacto a"
      );

      if (contactoLink.length) {
        event.preventDefault(); // previene el salto si es <a href="#">

        console.log("Scroll to footer");

        // Anima el menú (si corresponde con t1.reversed)
        t1.reverse();

        // Espera a que acabe la animación del menú (ajusta el tiempo si es necesario)
        setTimeout(function() {
          const footer = $("#footer");
          if (footer.length) {
            $("html, body").animate(
              {
                scrollTop: footer.offset().top
              },
              1500
            );
          }
        }, 1200); // Ajusta este tiempo según tu animación
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header-nav").length) {
      return;
    }

    initMenu();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
